import { render } from "./TruckIcon.vue?vue&type=template&id=954313b6"
import script from "./TruckIcon.vue?vue&type=script&lang=js"
export * from "./TruckIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__